import { render, staticRenderFns } from "./Appendices.vue?vue&type=template&id=6cd6d2ba&scoped=true&"
import script from "./Appendices.vue?vue&type=script&lang=js&"
export * from "./Appendices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd6d2ba",
  null
  
)

export default component.exports